import React from 'react';
import PropTypes from 'prop-types';

import {Dropdown} from 'views/components';
import {translate} from 'views/module';

import {MenuItem} from '@mui/material';

const StageDropdown = (props) => {
  const {selectedStage, setSelectedStage} = props;

  const stages = Object.entries(translate('client.Status'));

  const handleOptionSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedStage(selectedOption);
    }
  };

  return (
    <Dropdown onChange={handleOptionSelect} value={selectedStage}label={translate('client.ClientDetail.Status.Menu.Subtitles.Stage')}>
      {
        stages.map(([k, v]) => {
          return (
            <MenuItem key={k} value={k}>{v.Title}</MenuItem>
          );
        })
      }
    </Dropdown>

  );
};

StageDropdown.propTypes = {
  selectedStage: PropTypes.string,
  setSelectedStage: PropTypes.func.isRequired,
};

export default StageDropdown;
